import { getAnchorScrollTop } from './_common';

/**
 * フッター／ハンバーガーメニュー内のリンクが「同一ページ内のアンカー」の場合、
 * スムーススクロールで移動する。
 * 別ページへのアンカー（例: 下層ページから / への #story）は通常遷移に任せる。
 */
export function smoothScrollFunc() {
  const scopes = document.querySelectorAll('.l-menu, .l-footer');

  scopes.forEach((scope) => {
    scope.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        let url;
        try {
          url = new URL(link.href, window.location.href);
        } catch (err) {
          return;
        }

        // 別ホスト／別ページのアンカーは通常遷移（遷移先ページ側でジャンプ）
        if (url.host !== window.location.host) return;
        if (url.pathname !== window.location.pathname) return;

        const hash = url.hash;
        if (!hash || hash === '#') return;

        let target = null;
        const targetId = decodeURIComponent(hash.slice(1));
        try {
          target = document.getElementById(targetId);
        } catch (err) {
          target = null;
        }
        if (!target) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const run = () => scrollToTarget(target, hash, targetId);

        // メニュー閉鎖（body overflow 解除・レイアウト確定）後に位置を測る
        const isMenuOpen = document.body.classList.contains('is-menu-open');
        if (isMenuOpen) {
          window.setTimeout(run, 100);
        } else {
          run();
        }
      });
    });
  });
}

function scrollToTarget(target, hash, targetId) {
  window.scrollTo({
    top: getAnchorScrollTop(target, targetId),
    behavior: 'smooth',
  });

  // URL のハッシュを更新（履歴は積まずに置き換え）
  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, '', hash);
  }
}
